import {
  encodeContext
} from "./../helpers/composables.js";
import { clientOptions } from "#nuxt-graphql-middleware/client-options";
import { useGraphqlState } from "#imports";
import { getEndpoint } from "#nuxt-graphql-middleware/helpers";
function createFormData(variables) {
  const formData = new FormData();
  formData.append("operations", "{}");
  const map = {};
  let fileIndex = 0;
  const traverseAndBuildMap = (obj, path) => {
    if (obj instanceof File) {
      const fileKey = `${fileIndex++}`;
      map[fileKey] = [path];
      formData.append(fileKey, obj);
      return null;
    }
    if (Array.isArray(obj)) {
      return obj.map(
        (item, index) => traverseAndBuildMap(item, `${path}.${index}`)
      );
    }
    if (typeof obj === "object" && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        newObj[key] = traverseAndBuildMap(obj[key], `${path}.${key}`);
      }
      return newObj;
    }
    return obj;
  };
  const cleanedVariables = traverseAndBuildMap(variables, "variables");
  formData.append("variables", JSON.stringify(cleanedVariables));
  formData.append("map", JSON.stringify(map));
  return formData;
}
export function useGraphqlUploadMutation(...args) {
  const [name, variables, fetchOptions = {}, overrideClientContext = {}] = typeof args[0] === "string" ? [args[0], args[1], args[2]?.fetchOptions, args[2]?.clientContext] : [
    args[0].name,
    args[0].variables,
    args[0].fetchOptions,
    args[0].clientContext
  ];
  if (!variables) {
    throw new Error(
      'Using "useGraphqlUploadMutation" without variables is not supported.'
    );
  }
  const state = useGraphqlState();
  const formData = createFormData(variables);
  const globalClientContext = clientOptions.buildClientContext ? clientOptions.buildClientContext() : {};
  const clientContext = encodeContext({
    ...globalClientContext,
    ...overrideClientContext
  });
  return $fetch(getEndpoint("upload", name), {
    ...state && state.fetchOptions ? state.fetchOptions : {},
    ...fetchOptions || {},
    params: {
      ...clientContext,
      ...fetchOptions.params || {}
    },
    method: "POST",
    body: formData
  }).then((v) => {
    return {
      ...v,
      data: v?.data,
      errors: v?.errors || []
    };
  });
}
